import { createSlice } from '@reduxjs/toolkit';
import { actions } from '.';
import { LawyerConnection, Message, Prematter } from '@law-connect/types';

interface PrematterState {
  pending: {
    fetchById?: boolean;
    fetchByConnectionId?: boolean;
    convertToMatter?: boolean;
  };
  errors: {
    fetchById?: string | null;
    fetchByConnectionId?: string | null;
    convertToMatter?: string | null;
  };
  data: {
    [preMatterId: string]: Prematter;
  }
  
}

const prematterState: PrematterState = {
  pending: {},
  errors: {},
  data: {},
};

const prematterSlice = createSlice({
  name: 'prematter',
  initialState: prematterState,
  // you cant have a reducer name match the thunk action
  reducers: {},
  extraReducers: (builder) => {
    // fetch single connection by id
    builder.addCase(actions.prematter.fetchById.pending, (state) => {
      state.errors.fetchById = null;
      state.pending.fetchById = true;
    });
    builder.addCase(
      actions.prematter.fetchById.fulfilled,
      (state, action) => {
        state.errors.fetchById = null;
        state.pending.fetchById = false;
        if(action.payload) {
          state.data[action.payload.id] = action.payload;
        }
      }
    );
    builder.addCase(
      actions.prematter.fetchById.rejected,
      (state, action) => {
        state.pending.fetchById = false;
        state.errors.fetchById = action.error.message;
      }
    );
    // fetch by connection id
    builder.addCase(actions.prematter.fetchByConnectionId.pending, (state) => {
      state.errors.fetchByConnectionId = null;
      state.pending.fetchByConnectionId = true;
    });
    builder.addCase(
      actions.prematter.fetchByConnectionId.fulfilled,
      (state, action) => {
        state.errors.fetchByConnectionId = null;
        state.pending.fetchByConnectionId = false;
        if(action.payload) {
          state.data[action.payload.id] = action.payload;
        }
      }
    );
    builder.addCase(
      actions.prematter.fetchByConnectionId.rejected,
      (state, action) => {
        state.pending.fetchByConnectionId = false;
        state.errors.fetchByConnectionId = action.error.message;
      }
    );
    // convert to matter
    builder.addCase(actions.prematter.convertToMatter.pending, (state) => {
      state.errors.convertToMatter = null;
      state.pending.convertToMatter = true;
    });
    builder.addCase(
      actions.prematter.convertToMatter.fulfilled,
      (state) => {
        state.errors.convertToMatter = null;
        state.pending.convertToMatter = false;
      }
    );
    builder.addCase(
      actions.prematter.convertToMatter.rejected,
      (state, action) => {
        state.pending.convertToMatter = false;
        state.errors.convertToMatter = action.error.message;
      }
    );
  },
});

// im not sure if this is good practice but it mimics what we used to do with dispatching actions
export const prematterActions = prematterSlice.actions;
export const prematterReducer = prematterSlice.reducer;
